import script from "./MediaToolsView.vue?vue&type=script&setup=true&lang=ts"
export * from "./MediaToolsView.vue?vue&type=script&setup=true&lang=ts"

import "./MediaToolsView.vue?vue&type=style&index=0&id=760be950&scoped=true&lang=scss"

import exportComponent from "../../../../../home/franc/adereso-bsp-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-760be950"]])

export default __exports__